
import React, { Component } from 'react';
import PubSub from 'pubsub-js';
import { Input, message } from "antd";
import './createBuildPage.less';
import build from "../../../imgs/item/build.png";
import close_btn from '../../../imgs/btn/close_btn.png';
import { judgeBuildingNameExist } from '../../../utils/meshUtils';
import { meshLog, SPGet, SPSet } from '../../../utils/spUtils';
import { createNewBuilding, selectOrUpdateBuilding } from '../../../utils/net/netUtils';


let isNew=true;
let cur_build;
export default class CreateBuildPage extends Component {   
    
    constructor(props) {
        super(props);
        this.state = {
            mTitle:"",
            ui_building: "",
            ui_company: "",
            ui_city: "",
            ui_address: "",
        };
    }

    componentDidMount() {
        PubSub.subscribe('update_build_data_ui', (msg, data) => {
            meshLog('update_build',data);
            if(data==""){
                isNew=true;
                this.setState({
                    mTitle:"Create Building",
                    ui_building: "",
                    ui_company: "",
                    ui_city: "",
                    ui_address: "",
                })
            }else{
                isNew=false;
                cur_build=data; 
                this.setState({
                    mTitle:"Update Building",
                    ui_building: cur_build.buildingName,
                    ui_company: cur_build.companyName,
                    ui_city: cur_build.city,
                    ui_address: cur_build.address,
                })
            }

        })
    }

    //编辑框
    item1Change= (event) => {
        meshLog('item1',event.target.value);
        this.setState({ ui_building: event.target.value });
    };
    item2Change= (event) => {
        meshLog('item2',event.target.value);
        this.setState({ ui_company: event.target.value });
    };
    item3Change= (event) => {
        meshLog('item3',event.target.value);
         this.setState({ ui_address: event.target.value });
    };
    item4Change= (event) => {
        meshLog('item4',event.target.value);
        this.setState({ ui_city: event.target.value });
    };

    //取消
    closeBtnClick(){
        this.props.onDataToParent("");
    };
    //保存
    saveBtnClick(){
        const { ui_building, ui_company, ui_city, ui_address } = this.state;
        if(ui_building==""){
            message.warning({content:"Please input your Building Name!",style:{fontSize:"25px"}});
            return;
        }
        if(ui_company==""){
            message.warning({content:"Please input your Company Name!",style:{fontSize:"25px"}});
            return;
        }
        if(ui_city==""){
            message.warning({content:"Please input your City!",style:{fontSize:"25px"}});
            return;
        }
        if(ui_address==""){
            message.warning({content:"Please input your Building Address!",style:{fontSize:"25px"}});
            return;
        }
        if(isNew){
            this.createNewBuild(ui_building, ui_company, ui_city, ui_address);
        }else{
            this.updateOldBuild(ui_building, ui_company, ui_city, ui_address);
        }
    };

    //创建新Build
    createNewBuild(name, company, city, address){   
        if(judgeBuildingNameExist(name,"")){
            message.warning({content:"Names exist",style:{fontSize:"25px"}});
            meshLog('Names exist');
            return;
        }
        createNewBuilding(name, company, city, address);
        this.props.onDataToParent("");
    }

    //更新Build
    updateOldBuild(name, company, city, address){
        if(judgeBuildingNameExist(name,cur_build.buildingName)){
            message.warning({content:"Names exist",style:{fontSize:"25px"}});
            meshLog('Names exist');
            return;
        }
        selectOrUpdateBuilding(cur_build.buildingUUID,name,company,city,address,1);  //更新
    }

  

    render() {
        const { ui_building, ui_company, ui_city, ui_address } = this.state;
        return (
            <div className="ui_dialog_bg">
                <div className="ui_grey_bg" />
                <div className="create_build_container" style={{left:(document.body.clientWidth-380)/2}}>
                    {/* 关闭按钮 */}
                    <img className='closeBtn' src={close_btn} onClick={() => { this.closeBtnClick() }}/>
                    {/* 1. Area Management 标题行 */}
                    <div className="build-row">
                        <div className="build-title">
                            <img className='icon' src={build}/>
                            <span>{this.state.mTitle}</span>
                        </div>
                    </div>

                    {/* 2. Create Building 区域 */}
                    <Input className="item1" placeholder="*Building Name" value={ui_building} maxLength={15} onChange={this.item1Change}/>
                    <Input className="item2" placeholder="*Company Name" value={ui_company} onChange={this.item2Change}/>
                    <Input className="item3" placeholder="*Building Address" value={ui_address} onChange={this.item3Change}/>
                    <Input className="item4" placeholder="*City" value={ui_city} onChange={this.item4Change}/>

                    <div className="build-footer">
                        <button className='cancelBtn' onClick={() => { this.closeBtnClick() }}>Cancel</button>
                        <button className='okBtn' onClick={() => { this.saveBtnClick() }}>Confirm</button>
                    </div>

                </div>
            </div>
            
        );
    }
}
